import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import noImage from "../../no_Image.jpg";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import "../../index.css";
import {
  setSelectedCamera,
  deleteCamera,
  setFinalData,
  updateCamera2,
  updateComparisonData,
  setSelectedCameraQuantity,
} from "../../../src/app/features/counter/counterSlice";
import { useSelector, useDispatch } from "react-redux";

import { CategoryCsvData } from "../fetchData/CategoryCsvData.js";
import { ProductCsvData } from "../fetchData/ProductCsvData.js";
import { ProductOptionsCsvData } from "../fetchData/ProductOptionsCsvData.js";
import DisplayDrops from "./DisplayDrops.js";
import WarningComponent from "./WarningComponent.js";
import { calculateLineItem, getProductSku, getProductDisplayName } from "./quoteCalculator";

function Cameras(props) {
  const { categoryCSVQuery, isLoading1, isOnline, isError1 } =
    CategoryCsvData();
  const { productCSVQuery } = ProductCsvData();
  const { productOptionCSVQuery } = ProductOptionsCsvData();
  const areYouDealer = useSelector((state) => state.counter1.areYouDealer);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedCameraNumber = useSelector(
    (state) => state.counter1.totalCamera
  );

  const totalNoOptions = useSelector((state) => state.counter1.totalNoOptions);
  const NumberOfDrops = useSelector(
    (state) => state.counter1.selectedNumberOfDrops
  );
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [shows, setShows] = useState(false);
  const [count, setCount] = useState(1);
  const [thumbimg, setThumbimg] = useState([]);
  const [totalPriceInTable, setTotalPriceInTable] = useState(0);
  const [filteredData, setfilteredData] = useState([]);
  const [categoryName, setCategoryName] = useState([]);
  const [filteredData2, setfilteredData2] = useState([]);
  const [categoryName2, setCategoryName2] = useState([]);
  const [finalDatas, setFinalDatas] = useState([]);
  const [dataProduct, setdataProduct] = useState({});
  const [finalNewState, setFinalNewState] = useState({});
  const [finalNewState2, setFinalNewState2] = useState({});
  const [totalPrice, setTotalPrice] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [priceList, setPriceList] = useState(0);
  const [unitCostInput, setUnitCostInput] = useState("");
  const [mergedState, setMergedState] = useState({});
  const [totalBracket, setTotalBracket] = useState(0);
  const [totalQty, setTotalQty] = useState(0);
  const [totalSelected, setTotalSelected] = useState(0);
  const [totalDrops, setTotalDrops] = useState(0);
  const [showButtons, setShowButtons] = useState(null);
  const [showWarningComponent, setShowWarningComponent] = useState(false);
  const [storeItem, setStoreItem] = useState(null);
  const [editOn, setEditOn] = useState(null);
  const [productStates, setProductStates] = useState({});
  const totalCameraSelectedFromRedux = useSelector(
    (state) => state.counter1.selectedCamera
  );

  const [disableIt, setDisableIt] = useState("");
  const [bracketPrice, setBracketPrice] = useState(0);
  const [bracketNumber, setBracketNumber] = useState(0);
  const totalbracketPrice = bracketPrice * bracketNumber;
  const [mainPrice2, setMainPrice2] = useState(
    finalNewState.Product_Base_Price
  );

  const [basePrice3, setBasePrice3] = useState(0);
  const whichOption = useSelector(
    (state) => state.counter1.whichOptionSelected
  );

  const [two, setTwo] = useState("");

  const csvCamera = [];
  totalCameraSelectedFromRedux.map((selectedItem) => {
    let optionName1;
    let optionValue1;
    let optionPrice1;
    let optionName3;
    let optionValue3;
    let optionPrice3;
    let optionName6;
    let optionValue6;
    let optionPrice6;
    if (selectedItem["Edge Backup Recording"]) {
      optionName1 = "Edge Backup Recording";
      optionValue1 = selectedItem["Edge Backup Recording"];
      optionPrice1 = selectedItem["Edge Backup Recording_price"];
    }
    if (selectedItem["Audio"]) {
      optionName6 = "Audio";
      optionValue6 = selectedItem["Audio"];
      optionPrice6 = selectedItem["Audio_price"];
    }
    if (selectedItem["Color"]) {
      optionName3 = "Color";
      optionValue3 = selectedItem["Color"];
      optionPrice3 = selectedItem["Color_price"];
    }
    csvCamera.push({
      option: selectedItem.num_options,
      uniqueID: selectedItem.uniqueID,
      category: "Camera",
      unit_price: Number(selectedItem.Product_Base_Price || selectedItem.unitprice || 0),
      Product_Name: selectedItem.Product_Name,
      Product_Description: selectedItem.Name,
      Name: selectedItem.Name || selectedItem.name,
      Product_Quantity: selectedItem.Product_Quantity,
      Product_Base_Price: selectedItem.Product_Base_Price,
      Product_Final_Price:
        selectedItem.Product_FinalPrice * selectedItem.Product_Quantity,
      option1_name: optionName1,
      option1_value: optionValue1,
      option1_price: optionPrice1,
      option2_name: "Mounting Bracket",
      option2_value: selectedItem["Mounting Bracket"],
      option2_price: selectedItem["Mounting Bracket_price"],
      option3_name: optionName3,
      option3_value: optionValue3,
      option3_price: optionPrice3,
      option4_name: "MicroSD Card for Edge Recording",
      option4_value: selectedItem["MicroSD Card for Edge Recording"],
      option4_price: selectedItem["MicroSD Card for Edge Recording_price"],
      option5_name: "Power Adapter",
      option5_value: selectedItem["Power Adapter"],
      option5_price: selectedItem["Power Adapter_price"],
      thumbnail: selectedItem?.thumbnail || "",
      image1: selectedItem?.image1 || "",
      image2: selectedItem?.image2 || "",
      image3: selectedItem?.image3 || "",
      image4: selectedItem?.image4 || "",

      // Only include the "Audio" option if selectedItem["Audio"] is true
      ...(selectedItem["Audio"] && {
        option6_name: optionName6,
        option6_value: optionValue6,
        option6_price: optionPrice6,
      }),
    });
  });

  const tableData = csvCamera;
  useEffect(() => {
    let totalCty = 0;
    tableData.forEach((item) => {
      totalCty += parseInt(item.Product_Quantity, 10);
    });
    setTotalQty(totalCty);
  }, [tableData]);

  useEffect(() => {
    let totalBkt = 0;
    tableData.forEach((item) => {
      const bracketSelected = parseInt(item.Bracket_Selected, 10);
      if (!isNaN(bracketSelected)) {
        totalBkt += bracketSelected;
      }
    });
    setTotalBracket(totalBkt);
  }, [tableData]);

  useEffect(() => {
    let total = 0;
    tableData.forEach((item) => {
      total += parseFloat(item.Product_FinalPrice);
    });
    setTotalPriceInTable(total);
  }, [tableData]);

  const updateMergedState = () => {
    setMergedState({
      ...finalNewState,
      ...finalNewState2,
    });
  };

  useEffect(() => {
    updateMergedState();
  }, [finalNewState, finalNewState2]);

  function addCamera(type, uniqueID = null) {
    const mergedState = {
      ...finalNewState,
      ...finalNewState2,
    };

    mergedState.num_options = whichOption;
    mergedState.type = type;
    if (type == "add") {
      mergedState.uniqueID =
        Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
    } else {
      mergedState.uniqueID = uniqueID;
    }

    dispatch(setSelectedCamera(mergedState));

    dispatch(setFinalData(mergedState));
    setShow2(false);
  }

  const handleButtonClick = (e, category_name) => {
    setCategoryName(category_name);
    setShow(true);

    const cameraData2 = productCSVQuery.filter((item) => {
      if (item.categories) {
        const categoriesWords = item.categories.split("/");
        if (areYouDealer === "Dealer Selected") {
          if (item.hide_2 === "0") {
            if (
              !categoriesWords.includes("Special") &&
              category_name !== "Special"
            ) {
              return categoriesWords.find((word) =>
                word.includes(category_name)
              );
            }
          }
        } else if (areYouDealer !== "Dealer Selected") {
          if (item.hide_1 === "0") {
            if (
              !categoriesWords.includes("Special") &&
              category_name !== "Special"
            ) {
              return categoriesWords.find((word) =>
                word.includes(category_name)
              );
            }
          }
        }
      }
    });
    setfilteredData(cameraData2);
  };


  function modal_1(e, item, id, type, uniqueID = null) {
    setEditOn(type);
    setStoreItem(item);
    // setStoreItem([]);
    setShowButtons(type);
    // Set the base price based on the type
    const basePrice =
      areYouDealer !== "Dealer Selected" ? item.price : item.price_2;
    if (type === "edit") {
      setBasePrice3(item.Product_Base_Price);
      setPriceList(item.unit_price); // Fallback to base price if unitprice missing
      setCount(item.Product_Quantity);
      // Calculate initial totalPrice from options
      let initialTotalPrice = 0;
      for (let i = 1; i <= 6; i++) {
        const optionPriceKey = `option${i}_price`;
        if (item[optionPriceKey]) {
          initialTotalPrice += parseFloat(item[optionPriceKey]);
        }
      }
      setTotalPrice(initialTotalPrice);
    } else {
      setBasePrice3(basePrice);
      setPriceList(basePrice); // Initialize priceList with base price
      setCount(1); // Default quantity for new items
      setTotalPrice(0);
    }

    // Find the product options based on product id
    let result = [];
    let currentArray = [];
    for (let i = 0; i < productOptionCSVQuery.length; i++) {
      const option = productOptionCSVQuery[i];
      if (
        option.productid === id ||
        (currentArray.length > 0 && option.productid === "")
      ) {
        currentArray.push(option);
      } else if (currentArray.length > 0) {
        result = currentArray;
        currentArray = [];
      }
    }
    if (currentArray.length > 0) {
      result = [...currentArray];
    }

    // Group the result by product id
    const result1 = [];
    let currentArray1 = [];
    for (let i = 0; i < result.length; i++) {
      const option = result[i];
      if (option.productid === id) {
        if (currentArray1.length > 0) {
          result1.push([...currentArray1]);
          currentArray1 = [];
        }
        currentArray1.push(option);
      } else if (currentArray1.length > 0 || i === result.length - 1) {
        currentArray1.push(option);
      }
    }

    if (currentArray1.length > 0) {
      result1.push([...currentArray1]);
    }
    setFinalDatas(result1);

    // const selectedOption = result1
    //   .flat()
    //   .find((option) => option.featurename === "No Brackets Needed");

    // Set the modal visibility and other state
    setShow2(true);
    setShow(false);
    setCategoryName2(id);

    let cameraData3;

    if (type === "edit") {
      const cameraData2 = productCSVQuery.filter((item1) => {
        if (item1.categories) {
          const categoriesWords = item1.categories.split("/");
          if (areYouDealer === "Dealer Selected") {
            return item1.hide_2 === "0";
            // return item1.hide_2 === "0" && categoriesWords.includes(item.Camera_Category_Name);
          } else {
            return item1.hide_1 === "0";
            // return item1.hide_1 === "0" && categoriesWords.includes(item.Camera_Category_Name);
          }
        }
        return false;
      });

      cameraData3 = cameraData2.filter((item1) => item1.id === id);
    } else {
      cameraData3 = filteredData.filter((item1) => item1.id === id);
    }

    cameraData3[0].uniqueID = uniqueID;
    setfilteredData2(cameraData3);
    setdataProduct(item);
  }

  const cameraData1 = categoryCSVQuery
    ? categoryCSVQuery.filter((item) => {
        return item.category_parent && item.category_parent.includes("45");
      })
    : [];

  // Remove blank id code
  const demoArr = [];
  if (productCSVQuery && cameraData1) {
    productCSVQuery.forEach((item1) => {
      cameraData1.forEach((item) => {
        if (item1.categories) {
          const categoriesWords = item1.categories.split("/");
          const testVariable = categoriesWords.find((word) =>
            word.includes(item.category_name)
          );

          if (areYouDealer === "Dealer Selected") {
            if (testVariable !== undefined && item1.hide_2 === "0") {
              demoArr.push(item);
            }
          } else {
            if (testVariable !== undefined && item1.hide_1 === "0") {
              demoArr.push(item);
            }
          }
        }
      });
    });

    // Sort after collecting all valid items
    demoArr.sort((a, b) => {
      return (parseInt(a.sorting) || 0) - (parseInt(b.sorting) || 0);
    });
  }

  function filterUniqueObjects(arr, property) {
    const uniqueSet = new Set();
    return arr.filter((obj) => {
      const value = obj[property];
      if (uniqueSet.has(value)) {
        return false;
      }
      uniqueSet.add(value);
      return true;
    });
  }

  const cameraData = filterUniqueObjects(demoArr, "id");

  useEffect(() => {
    // storing data

    const liveUnitTotal = Number(basePrice3 || 0) + Number(totalPrice || 0);

    let newState = {
      num_options: whichOption,
      Product_Name: categoryName2,
      Name: dataProduct?.name || dataProduct?.Name,
      Product_Base_Price: basePrice3,
      Product_FinalPrice: liveUnitTotal,
      Product_Quantity: count,
      Camera_Category_Name: categoryName,
      unitprice: liveUnitTotal,
      pricePerItem: basePrice3,
      unit_price: basePrice3,
      thumbnail: dataProduct?.thumbnail || "",
      image1: dataProduct?.image1 || "",
      image2: dataProduct?.image2 || "",
      image3: dataProduct?.image3 || "",
      image4: dataProduct?.image4 || "",
    };

    if (
      dataProduct?.extra_field_2 !== undefined &&
      dataProduct?.extra_field_2 !== ""
    ) {
      newState = {
        ...newState,
        drop: parseFloat(dataProduct.extra_field_2),
      };
    }

    setFinalNewState(newState);
  }, [
    dataProduct.id,
    dataProduct.price,
    count,
    priceList,
    totalPrice,
    bracketNumber,
    categoryName,
  ]);

  //***** Below Code is responsible for filling finalNewState-2 *******//
  useEffect(() => {
    const initialSelectedOptions = {};
    if (editOn === "edit") {
      // Loop through all possible options (1 to 6)
      for (let i = 1; i <= 6; i++) {
        const optionNameKey = `option${i}_name`;
        const optionValueKey = `option${i}_value`;
        const optionPriceKey = `option${i}_price`;

        // Check if the option exists on the storeItem
        if (storeItem[optionNameKey] && storeItem[optionValueKey]) {
          // Add option name and value to initialSelectedOptions
          initialSelectedOptions[storeItem[optionNameKey]] =
            storeItem[optionValueKey];

          // Add price with the correct option name and '_price' suffix
          initialSelectedOptions[storeItem[optionNameKey] + "_price"] =
            storeItem[optionPriceKey];
        }
      }
    } else {
      finalDatas.forEach((item) => {
        if (item.length > 0) {
          const firstOption = item[0];
          initialSelectedOptions[firstOption.featurecaption] =
            firstOption.featurename;
          initialSelectedOptions[firstOption.featurecaption + "_price"] =
            firstOption.featureprice;
        }
      });
    }
    setFinalNewState2(initialSelectedOptions);
  }, [finalDatas]);
  //***** Below Code is responsible for filling finalNewState-2 *******//

  //************************** HandleChange ***************************//

  function handleSelectChange(e) {
    const { name, value } = e.target;
    const selectedOption = finalDatas
      .flat()
      .find((option) => option.featurename === value);
    setDisableIt(selectedOption.featurename);

    if (name === "Mounting Bracket") {
      setBracketPrice(selectedOption.featureprice);
    }
    if (name === "Audio") {
      setTwo(selectedOption.featureprice);
    }

    const prevOptionPrice =
      finalNewState2[name] &&
      finalDatas
        .flat()
        .find((option) => option.featurename === finalNewState2[name])
        ? parseFloat(
            finalDatas
              .flat()
              .find((option) => option.featurename === finalNewState2[name])
              .featureprice
          )
        : 0;

    const optionPrice = selectedOption
      ? parseFloat(selectedOption.featureprice)
      : 0;

    const priceDifference = optionPrice - prevOptionPrice;

    // Update total price
    setTotalPrice((prevTotalPrice) => prevTotalPrice + priceDifference);

    // priceList is derived from basePrice3 + selected option total in the shared useEffect.

    setFinalNewState2((prevData) => ({
      ...prevData,
      [name]: value,
      [name + "_price"]: optionPrice,
    }));
  }

  const handlePlusClick = () => {
    setCount(count + 1);
  };

  const handleMinusClick = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  // Increase Count by + 5
  const handlePlusClickByFive = () => {
    setCount(count + 5);
  };

  // Decrease Count by - 5
  const handleMinusClickByFive = () => {
    if (count > 5) {
      setCount(count - 5);
    }
  };

  // Increase Count by +10 :
  const handlePlusClickByTen = () => {
    setCount(count + 10);
  };
  // Decrease Count by -10
  const handleMinusClickByTen = () => {
    if (count > 10) {
      setCount(count - 10);
    }
  };

  // New
  //**************** calculate price *************//

  useEffect(() => {
    // Keep add and edit flyouts consistent: unit price is always base unit cost + selected option cost.
    const totalPrice2 = Number(basePrice3 || 0) + Number(totalPrice || 0);
    setPriceList(totalPrice2);
  }, [totalPrice, basePrice3]);

  //
  const resetState = () => {
    if (editOn !== "edit") {
      // Only reset if not in edit mode
      // setPriceList(0);
      setBracketNumber("");
      setTotalPrice(0);
      setIsDisabled(true);
      setCount(1);
      setBracketPrice(0);
      setThumbimg([]);
    }
  };

  React.useEffect(() => {
    updateMergedState();
    if (!show2 && editOn !== "edit") {
      // Only reset if not in edit mode
      resetState();
    }
    if (!shows) {
      resetState();
    }
  }, [show2, shows]);

  //************* Delete Camera **********//

  const deleteFromCamera = (uniqueID, option) => {
    dispatch(deleteCamera({ uniqueID, option }));
  };

  // +1 by Unit Cost
  const typedDecrement = () => {
    setUnitCostInput("");
    setBasePrice3((prev) => Math.max(0, (Number(prev) || 0) - 1));
  };

  // +1 Unit Cost
  const typedIncrement = () => {
    setUnitCostInput("");
    setBasePrice3((prev) => (Number(prev) || 0) + 1);
  };

  // Input Type Unit Cost. This edits the base unit cost only; option prices stay separate.
  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*(\.\d{0,2})?$/.test(value)) {
      setUnitCostInput(value);
      setBasePrice3(value === "" || value === "." ? 0 : parseFloat(value));
    }
  };

  const handleUnitCostFocus = () => {
    setUnitCostInput(String(basePrice3 ?? ""));
  };

  const handleUnitCostBlur = () => {
    setUnitCostInput("");
  };

  const getLiveUnitTotal = () => Number(basePrice3 || 0) + Number(totalPrice || 0);

  //filter table data based on num_option selected
  const filterData = tableData.filter((item) => item.option === whichOption);

  useEffect(() => {
    //This is to count total number of camera selected in a specific options
    let numberOfCameras = 0;

    filterData.forEach((item) => {
      if (item.Product_Quantity) {
        numberOfCameras += item.Product_Quantity;
      }
    });
    dispatch(setSelectedCameraQuantity({ [whichOption]: numberOfCameras }));
    setTotalSelected(numberOfCameras);

    if (whichOption && totalNoOptions !== undefined) {
      dispatch(
        updateComparisonData({
          [whichOption]: {
            name: "cameras",
            quantity: numberOfCameras || 0,
            warning: selectedCameraNumber || 0,
            option: whichOption,
            navigationName: "/cameras",
          },
        })
      );
    }
  }, [filterData]);

  const formatPrice = (price) => {
    // First round to 2 decimal places to fix floating point issues
    const rounded = Math.round(price * 100) / 100;
    // Then format with exactly 2 decimal places
    return rounded.toFixed(2);
  };

  return (
    <>
      <Container fluid className="my-4">
        <Container className="navbar_margin">
          <Row>
            <Col className="marginTopSpace">
              <h2>
                Camera <span className="fst-italic fs-6">(Category)</span>
              </h2>
            </Col>
            <Col className="marginTopSpace">
              <Row>
                <Col className="text-end">
                  Number of Cameras Required:&nbsp;
                  <span className="fw-bold">{selectedCameraNumber}</span>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  Total Cameras Selected:&nbsp;
                  <span className="fw-bold">{totalSelected}</span>
                </Col>
              </Row>

              <Row>
                <Col className="text-end">
                  <DisplayDrops />
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  <Link to="/">
                    <h6>
                      Edit here <span className="fw-bold"></span>
                    </h6>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="" style={{ padding: "0px 8px" }}>
            <Col>
              <h5 className="fw-bold">Add to Cart: </h5>
              <div className="table-border">
                <Table striped bordered hover responsive>
                  <colgroup>
                    <col style={{ width: "160px" }} />
                    <col style={{ width: "auto" }} />
                    <col style={{ width: "110px" }} />
                    <col style={{ width: "80px" }} />
                    <col style={{ width: "120px" }} />
                    <col style={{ width: "90px" }} />
                    <col style={{ width: "90px" }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>SKU:</th>
                      <th>Description & Options</th>
                      <th>Price: </th>
                      <th>QTY: </th>
                      <th>Total: </th>
                      <th colSpan={2} className="text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filterData.map((item, index) => {
                      const calc = calculateLineItem(item);
                      return (
                        <tr key={item.uniqueID || getProductSku(item) || index}>
                          <td style={{ whiteSpace: "nowrap" }}>{getProductSku(item)}</td>
                          <td>
                            {item.Product_Name ? (
                              <>
                                <strong>{getProductDisplayName(item)}</strong>
                                {/* {item.category} */}
                                <br />
                              </>
                            ) : null}
                            {item && item.option1_value ? (
                              <>
                                <strong>{item.option1_name}:</strong>{" "}
                                {item.option1_value}{" "}
                                <strong>${item.option1_price}</strong>
                                <br />
                              </>
                            ) : null}
                            {item && item.option2_value ? (
                              <>
                                <strong>{item.option2_name}:</strong>{" "}
                                {item.option2_value}{" "}
                                <strong>${item.option2_price}</strong>
                                <br />
                              </>
                            ) : null}
                            {item && item.option3_value ? (
                              <>
                                <strong>{item.option3_name}: </strong>
                                {item.option3_value}{" "}
                                <strong>${item.option3_price}</strong>
                                <br />
                              </>
                            ) : null}
                            {item && item.option4_value ? (
                              <>
                                <strong>{item.option4_name}: </strong>
                                {item.option4_value}{" "}
                                <strong>${item.option4_price}</strong>
                                <br />
                              </>
                            ) : null}
                            {item && item.option5_value ? (
                              <>
                                <strong>{item.option5_name}: </strong>
                                {item.option5_value}{" "}
                                <strong>${item.option5_price}</strong>
                              </>
                            ) : null}
                            {item && item.option6_value ? (
                              <>
                                <strong>{item.option6_name}: </strong>
                                {item.option6_value}{" "}
                                <strong>${item.option6_price}</strong>
                              </>
                            ) : null}
                          </td>
                          <td>${calc.unitTotal.toFixed(2)}</td>
                          <td>{calc.quantity}</td>
                          <td>${calc.lineTotal.toFixed(2)}</td>
                          <td>
                            <Button
                              variant="dark"
                              className="mx-3"
                              onClick={(e) =>
                                modal_1(
                                  e,
                                  item,
                                  item.Product_Name,
                                  "edit",
                                  item.uniqueID
                                )
                              }
                            >
                              Edit
                            </Button>
                          </td>
                          <td>
                            <Button
                              variant="dark"
                              onClick={() => {
                                deleteFromCamera(item.uniqueID, item.option);
                              }}
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>

          {/* Show the warning to the before he moves to the next category */}
          <div className="d-flex justify-content-end align-items-center">
            {showWarningComponent ? (
              <WarningComponent
                path="/poe-switch"
                setShowWarningComponent={setShowWarningComponent}
              />
            ) : (
              ""
            )}
            <Button
              variant="dark"
              onClick={() => setShowWarningComponent(true)}
            >
              Next
            </Button>
          </div>

          {/* Box */}
          <Row className="my-4">
            {cameraData.map((item, index) => {
              return (
                <Col
                  key={`${item.category_name + index}` || index}
                  md={4}
                  className="mb-4"
                  onClick={(e) => handleButtonClick(e, item.category_name)}
                >
                  <Card style={{ width: "", margin: "" }}>
                    <Card.Body>
                      <Row
                        style={{
                          height: "185px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Col xs={7}>
                          <Card.Img
                            variant="top"
                            style={{
                              width: "100%",
                              height: "100%",
                              maxHeight: "200px",
                              objectFit: "contain",
                              // aspectRatio: "1",
                              border: "0px solid grey",
                            }}
                            src={
                              item.iconimage === ""
                                ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                                : "https://platinumcctv.com/" + item.iconimage
                            }
                          />
                        </Col>
                        <Col
                          xs={5}
                          className=" align-items-center justify-content-center fw-bold"
                        >
                          <Card.Text className="fs-6">
                            {item.category_name}
                          </Card.Text>
                          <p className="camera_category_title">
                            {item.category_title || item.category_name}
                            <br />
                            {item.category_description.split(" ").length > 12
                              ? `${item.category_description
                                  .split(" ")
                                  .slice(0, 12)
                                  .join(" ")}...`
                              : item.category_description}
                          </p>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>

          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={() => setShow(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>{categoryName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="my-4">
                {filteredData
                  .sort((a, b) => parseInt(a.sorting) - parseInt(b.sorting))
                  .map((item, index) => {
                    return (
                      <Col
                        key={`${item.id + index}` || index}
                        md={4}
                        className="nvr_col my-2"
                        onClick={(e) => modal_1(e, item, item.id, "add")}
                      >
                        <Card
                          style={{
                            width: "",
                            backgroundColor: "",
                            height: "300px",
                          }}
                        >
                          <Card.Body>
                            <Card.Title className="fw-bold">
                              SKU : {item.id}
                            </Card.Title>
                            <Card.Text>
                              Description :
                              {item.description
                                .split(" ")
                                .slice(0, 10)
                                .join(" ")}
                              ...
                            </Card.Text>

                            <Row>
                              <Col xs={8}>
                                <Card.Img
                                  variant="top"
                                  height={100}
                                  src={
                                    item.thumbnail === ""
                                      ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                                      : "https://platinumcctv.com/" +
                                        item.thumbnail
                                  }
                                />
                              </Col>
                              <Col
                                xs={4}
                                className="d-flex align-items-center justify-content-center fw-bold"
                              >
                                ${" "}
                                {areYouDealer !== "Dealer Selected"
                                  ? item.price
                                  : item.price_2}
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="dark" onClick={() => setShow(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show2}
            onHide={() => {
              setShow2(false);
              setEditOn(null); // Clear edit mode when closing
            }}
          >
            <Modal.Header closeButton>
              <Modal.Title>{categoryName2}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Container>
                <Row>
                  {filteredData2.map((val, index) => {
                    const uniqueKey = `${val.id}-${index}`;
                    return (
                      <React.Fragment key={uniqueKey}>
                        <Col md={5}>
                          <Row>
                            <Card.Img
                              variant="top"
                              style={{
                                objectFit: "cover",
                                width: "200px",
                                height: "auto",
                                margin: "0 auto",
                              }}
                              src={
                                thumbimg.img1
                                  ? thumbimg.img1
                                  : "https://platinumcctv.com/" + val["image1"]
                              }
                            />
                          </Row>
                          <Row className="my-2">
                            {["image1", "image2", "image3", "image4"].map(
                              (imgKey, imgIndex) => (
                                <Col key={imgKey}>
                                  <Card.Img
                                    variant="top"
                                    height={40}
                                    className="camera_thumbnail_img"
                                    // src={
                                    //   "https://platinumcctv.com/" + val[imgKey]
                                    // }
                                    src={
                                      val[imgKey] === ""
                                        ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                                        : "https://platinumcctv.com/" +
                                          val[imgKey]
                                    }
                                    onClick={() =>
                                      setThumbimg({
                                        img1:
                                          "https://platinumcctv.com/" +
                                          val[imgKey],
                                      })
                                    }
                                  />
                                </Col>
                              )
                            )}
                          </Row>
                          {/* Final Price */}
                          <Row className="tops">
                            <div className="w-100 my-1 d-flex align-items-start">
                              <div className="text">
                                <Table
                                  striped
                                  bordered
                                  hover
                                  responsive
                                  style={{ width: "14rem" }}
                                ></Table>
                              </div>
                            </div>
                          </Row>
                          {/* Final Price */}
                        </Col>

                        <Col md={7}>
                          <p className="fst-italic">
                            <span className="fw-bold">Description: </span>
                            {val.description}
                          </p>
                          {/* Add Dropdown */}
                          {finalDatas.map((item, itemIndex) => (
                            <div key={itemIndex}>
                              <Form.Label>{item[0].featurecaption}</Form.Label>
                              <Form.Select
                                aria-label="Default select example"
                                className="mb-3"
                                name={item[0].featurecaption}
                                value={
                                  finalNewState2[item[0].featurecaption] || ""
                                }
                                onChange={handleSelectChange}
                              >
                                {item.map((option, optionIndex) => (
                                  <option
                                    key={optionIndex}
                                    value={option.featurename}
                                  >
                                    {`${option.featurename} $${option.featureprice}`}
                                  </option>
                                ))}
                              </Form.Select>
                            </div>
                          ))}

                          <div className="d-flex align-items-end justify-content-between my-4">
                            Qty :
                            <Button
                              variant="dark"
                              onClick={handleMinusClickByTen}
                            >
                              -10
                            </Button>
                            <Button
                              variant="dark"
                              onClick={handleMinusClickByFive}
                            >
                              -5
                            </Button>
                            <Button variant="dark" onClick={handleMinusClick}>
                              -
                            </Button>
                            <h6 className="mx-3">{count}</h6>
                            <Button variant="dark" onClick={handlePlusClick}>
                              +
                            </Button>
                            <Button
                              variant="dark"
                              onClick={handlePlusClickByFive}
                            >
                              +5
                            </Button>
                            <Button
                              variant="dark"
                              onClick={handlePlusClickByTen}
                            >
                              +10
                            </Button>
                          </div>

                          <div>
                            <h6 className="text-end mt-4 d-none">
                              Base Price: {basePrice3}
                            </h6>

                            <h6 className="text-end mt-4">
                              Option Price: {totalPrice.toFixed(2)}
                            </h6>
                          </div>

                          <div className="d-flex align-items-center justify-content-end">
                            <InputGroup className="mb-3">
                              <Button
                                variant="dark"
                                className="mx-3"
                                onClick={typedDecrement}
                              >
                                -
                              </Button>
                              <Form.Control
                                type="text"
                                value={unitCostInput !== "" ? unitCostInput : formatPrice(basePrice3)}
                                onFocus={handleUnitCostFocus}
                                onBlur={handleUnitCostBlur}
                                onChange={handleInputChange}
                              />
                              <Button
                                variant="dark"
                                className="mx-3"
                                onClick={typedIncrement}
                              >
                                +
                              </Button>
                            </InputGroup>
                          </div>
                          <h6 className="text-end mt-4">
                            Total Price: $
                            {calculateLineItem(
                              {
                                pricePerItem: getLiveUnitTotal(),
                                quantity: Number(count || 1),
                              },
                              { optionUnitTotal: 0 }
                            ).lineTotal.toFixed(2)}
                          </h6>
                        </Col>
                      </React.Fragment>
                    );
                  })}
                </Row>
              </Container>
            </Modal.Body>
            <Modal.Footer>
              <div className="w-100 my-4 d-flex align-items-end justify-content-between">
                <Button
                  className="mx-3"
                  variant="dark"
                  onClick={() => setShow2(false)}
                >
                  Back
                </Button>
                {/* Update Button */}
                {showButtons === "edit" ? (
                  <Button
                    variant="dark"
                    onClick={() => addCamera("edit", filteredData2[0].uniqueID)}
                  >
                    Update Camera
                  </Button>
                ) : (
                  <Button variant="dark" onClick={() => addCamera("add")}>
                    Add
                  </Button>
                )}
              </div>
            </Modal.Footer>
          </Modal>
        </Container>
      </Container>
    </>
  );
}

export default Cameras;
